(function() {
    if (customElements.get('base-button') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
          --base-button-bg: #333333;
          --base-button-bg-hover: #222222;
          --base-button-fg: #ffffff;
          --base-button-focus-color: crimson;
          --base-button-focus-outline: 4px solid var(--base-button-focus-color);
          --base-button-padding-v: .5em;
          --base-button-padding-h: 1em;
          --base-button-radius: 4px;
          --base-button-transition-duration: .25s;
          --base-button-transition-timing-function: ease;
          --base-button-disabled-opacity: .5;
          --base-button-cursor: default;
        
          /* do not set externally */
          --base-button-internal-bg: var(--base-button-bg);
        
          appearance: none;
          border-radius: var(--base-button-radius);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          cursor: var(--base-button-cursor);
          padding: var(--base-button-padding-v) var(--base-button-padding-h);
          background: var(--base-button-internal-bg);
          color: var(--base-button-fg);
          transition:
            background var(--base-button-transition-duration) var(--base-button-transition-timing-function),
            color var(--base-button-transition-duration) var(--base-button-transition-timing-function),
            outline var(--base-button-transition-duration) var(--base-button-transition-timing-function);
        }
        [part="content"] {
          display: block;
        }
        :host(:not([disabled]):is(:hover,:focus,:focus-within)) {
          --base-button-internal-bg: var(--base-button-bg-hover);
        }
        :host([disabled]) {
          pointer-events: none;
          opacity: var(--base-button-disabled-opacity);
        }
        :host([focus-visible]) {
          outline: var(--base-button-focus-outline);
        }
        :host([cursor="pointer"]) {
          --base-button-cursor: pointer;
        }
        [part="original"] {
          position: absolute;
          width: 1px;
          height: 1px;
          opacity: .001;
          z-index: -1;
          overflow: hidden;
        }
        </style>
        <div part="content">
            <slot></slot>
        </div>
        <span part="original">
           <slot name="click-element"></slot>
        </span>
        `
        customElements.define('base-button', class extends HTMLElement {
            constructor() {
                super();
                this.clickElement = null;
                this.preventInit = false;
                this.initTimeout = 0;
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }

            connectedCallback() {
                this.init();
                new MutationObserver(() => this.init()).observe(this, {
                    childList: true,
                    subtree: true,
                });
                this.addEventListener('slotchange', () => this.init());
                this.addEventListener('click', (event) => {
                    if (this.clickElement && event.target !== this.clickElement) {
                        this.clickElement.click();
                    }
                }, {
                    capture: true
                });
            }

            init() {
                if (this.preventInit === true) {
                    return;
                }
                clearTimeout(this.initTimeout);
                this.initTimeout = setTimeout(() => {
                    const oldClickElement = this.clickElement;
                    this.clickElement = this.querySelector('*[slot="click-element"]');
                    if (this.clickElement && this.clickElement !== oldClickElement) {
                        if (this.clickElement instanceof HTMLAnchorElement && this.clickElement.hasAttribute('href') && !this.hasAttribute("cursor")) {
                            this.setAttribute('cursor', 'pointer');
                        }
                        if (this.clickElement instanceof HTMLButtonElement || this.clickElement instanceof HTMLInputElement) {
                            const setDisabled = () => {
                                if (this.clickElement.hasAttribute('disabled') || this.clickElement.disabled) {
                                    this.setAttribute('disabled', 'disabled');
                                } else {
                                    this.removeAttribute('disabled');
                                }
                            };
                            new MutationObserver(setDisabled).observe(this.clickElement, {
                                attributes: true,
                                attributeFilter: ['disabled']
                            });
                            setDisabled();
                            this.clickElement.addEventListener('focus', () => {
                                this.setAttribute('focus-visible', 'focus-visible');
                            });
                            this.clickElement.addEventListener('blur', () => {
                                this.removeAttribute('focus-visible');
                            });
                        }
                    }
                    const defaultSlot = this.shadowRoot.querySelector('slot:not([name])');
                    const defaultSlotChildren = defaultSlot.assignedNodes()
                        .filter(node => !(node instanceof Text && node.data.trim() === ""));
                    if (defaultSlotChildren.length === 0) {
                        this.cloneToDefaultSlot();
                    }
                }, 10);
            }

            cloneToDefaultSlot() {
                if (!(this.clickElement instanceof HTMLElement)) {
                    return;
                }
                this.preventInit = true;
                this.clickElement.childNodes.forEach(node => {
                    if (node instanceof Element) {
                        this.insertAdjacentElement('beforeend', node.cloneNode(true));
                    } else if (node instanceof Text) {
                        this.insertAdjacentText('beforeend', node.data);
                    }
                });
                this.preventInit = false;
            }
        });
    }
})();
